import type { DIAMError, ErrorResponse } from '~/types/error-responses.types';
import { mapIAMErrorsToBFFErrors } from '~/utils/iam-error-mapper/iam-error-mapper';
import BaseException from '~/utils/fetch-wrapper/errors/BaseException';

export default class DIAMException extends BaseException {
  readonly name = 'DIAMException';

  constructor(response: ErrorResponse<DIAMError>) {
    super({
      ...response,
      errors: response.errors ? mapIAMErrorsToBFFErrors(response.errors) : [],
    });

    this._raw = response;
  }
}
